const styles = {
  container: {
    padding: '15px',
  },
  fillHeight: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
  },
  title: {
    '&&': {
      margin: '0 0 1em 0',
    },
  },
};

export default styles;
